module.exports = __webpack_public_path__ + "static/images/performance.80b35e9bbff7a7699a5c08a3623a785e.svg";